

































import {
    defineComponent,
    reactive,
    toRefs,
    computed,
} from '@vue/composition-api';

export default defineComponent({
    name: 'input-text',
    props: {
        type: {
            type: String,
            default: 'text',
        },
        width: {
            type: String,
            default: '280',
        },
        height: {
            type: String,
            default: '28',
        },
        name: {
            type: String,
            default: '默认',
        },
        required: {
            type: Boolean,
            default: true,
        },
        maxLen: {
            type: Number,
            default: 524288,
        },
        minLen: {
            type: Number,
            default: 1,
        },
        placeholder: String,
        value: String,
        showWordLimit: {
            type: Boolean,
            default: false,
        },
        step: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 0,
        },
        min: {
            type: Number,
            default: 0,
        },
    },
    model: {
        prop: 'value',
        event: 'update',
    },
    setup(props, context) {
        const inputVal = computed({
            get: () => {
                return props.value;
            },
            set: (val) => {
                return context.emit('update', val);
            },
        });
        return {
            inputVal,
        };
    },
});
